export default "__VITE_ASSET__23MgYuYs__"